import { makeGetRequest } from 'lib/axios';

export type SclaApplicationYearStatus = 'open' | 'upcoming' | 'closed';

export type SclaApplicationYear = {
  cohortYear: string;
  opensAt: string;
  closesAt: string;
  status: SclaApplicationYearStatus;
};

export type SclaApplicationYears = {
  years: SclaApplicationYear[];
  currentCohortYear: string | null;
  serverTime: string;
};

let cached: SclaApplicationYears | null = null;
let inflight: Promise<SclaApplicationYears> | null = null;

export function getCachedSclaApplicationYears(): SclaApplicationYears | null {
  return cached;
}

export function loadSclaApplicationYears(): Promise<SclaApplicationYears> {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = makeGetRequest('/scla/application-years')
      .then(response => {
        cached = response.data.payload as SclaApplicationYears;
        return cached;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}
